import { Button, Switch } from "@mui/material";
import { useAppServices } from "hook/services";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import deleteIcon from "../../../../../assets/themeIcons/delete-icon.svg";
import editIcon from "../../../../../assets/themeIcons/edit-icon.svg";
import nextIcon from "../../../../../assets/themeIcons/next.svg";
import previousIcon from "../../../../../assets/themeIcons/previous.svg";
import toast from "react-hot-toast";
import Select from "react-select";
import { useAgencyInfo } from "context/agency";
import { HiArrowsUpDown } from "react-icons/hi2";
import "./accountsAllAccounts.css";

/** Match search input and listing-label Select (height, border, radius). */
const TOOLBAR_FIELD_HEIGHT = 36;
const TOOLBAR_FIELD_HEIGHT_COMPACT = 36;
const TOOLBAR_SEARCH_MAX_WIDTH = 275;
const TOOLBAR_BORDER = "1px solid #cccccc";
const TOOLBAR_RADIUS = 5;
const TOOLBAR_FONT_SIZE = 16;
const TOOLBAR_FONT_SIZE_COMPACT = 13;
const TOOLBAR_TEXT = "#111827";
const TOOLBAR_PLACEHOLDER = "#667085";

/** Sentinel value for label filter: listings with no `business_tags` (or empty array). */
const LISTING_FILTER_NO_LABELS = "__NO_LISTING_LABELS__";

/** Mirrors backend `accounts/services.js` SearchListing: words are AND’ed; each word matches if any of these fields matches (case-insensitive substring). */
const escapeSearchRegex = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const matchesHomepageSearchListing = (item, rawQuery) => {
  const term = String(rawQuery || "").trim();
  if (!term) return true;
  const words = term.split(/\s+/).filter(Boolean);
  return words.every((word) => {
    const re = new RegExp(escapeSearchRegex(word), "i");
    const tryStr = (v) => (v != null && v !== "" ? re.test(String(v)) : false);
    if (tryStr(item?.first_name)) return true;
    if (tryStr(item?.business_name)) return true;
    if (tryStr(item?.city)) return true;
    if (tryStr(item?.state)) return true;
    if (tryStr(item?.country)) return true;
    if (tryStr(item?.phone)) return true;
    const tags = item?.business_tags;
    if (Array.isArray(tags)) {
      for (const t of tags) {
        const lab = t && typeof t === "object" ? t.label ?? t.name : t;
        if (lab != null && lab !== "" && re.test(String(lab))) return true;
      }
    }
    return false;
  });
};

/** Same circular hit-area for first / prev / next / last pagination controls */
const PAGINATION_ARROW_BTN = {
  width: 40,
  height: 40,
  padding: 0,
  margin: "0 5px",
  backgroundColor: "white",
  color: "black",
  border: "none",
  borderRadius: "50%",
  boxShadow: "0px 1px 4px 0px #181A2012",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
};

const NewTable = ({ data, onLoad, FreeAccount, type }) => {
  const isCompactAccountsTab = type === "all" || type === "premium" || type === "free";
  const toolbarFontSize = isCompactAccountsTab ? TOOLBAR_FONT_SIZE_COMPACT : TOOLBAR_FONT_SIZE;
  const toolbarFieldHeight = isCompactAccountsTab ? TOOLBAR_FIELD_HEIGHT_COMPACT : TOOLBAR_FIELD_HEIGHT;
  const AppService = useAppServices();
  const navigate = useNavigate();
  const [agency] = useAgencyInfo();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [availablePlan, setAvailablePlan] = useState({});
  const [selectedPlanId, setSelectedPlanId] = useState(null);
  const [isSubModelOpen, setIsSubModelOpen] = useState(false);
  const [selectedPlanSubscribe, setSelectedPlanSubscribe] = useState(null);
  const [selectedPlanSubscribeId, setSelectedPlanSubscribeId] = useState(null);
  const [changeModelOpen, setChangeModelOpen] = useState(false);
  const [changePlan, setChangePlan] = useState(null);
  const [changePlanId, setChangePlanId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showTagsPopup, setShowTagsPopup] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showPopupModelTags, setShowPopupModelTags] = useState(false);
  const [businessTags, setBusinessTags] = useState([]);
  const [selectedBusinessTags, setSelectedBusinessTags] = useState([]);
  const [tagActionType, setTagActionType] = useState("add");
  const [tagsToDelete, setTagsToDelete] = useState([]);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [businessToDelete, setBusinessToDelete] = useState(null);
  const [deleteConfirmText, setDeleteConfirmText] = useState("");
  const [deleting, setDeleting] = useState(false);

  console.log(tagsToDelete, "tagsToDelete");
  const GetBusinessTypes = async () => {
    const { response } = await AppService.business_types.get_all_types({
      query: `agency_id=${agency._id}`,
    });
    if (response) {
      setBusinessTags(
        response.tags
          .sort((a, b) => a.order - b.order)
          .map((item) => ({
            label: String(item?.name ?? "").trim() ? item.name : "(none)",
            value: item._id,
          }))
      );
    }
  };

  useEffect(() => {
    GetBusinessTypes();
  }, []);

  const handleTagsPopup = (type = "add") => {
    setTagActionType(type);
    setShowPopupModelTags(true);
  };
  const handleChange = (option) => {
    setSelectedPlanId(option);
  };
  const handleSubscribeChange = (option) => {
    setSelectedPlanSubscribeId(option);
  };
  const handlePlanConfigureChange = (option) => {
    setChangePlanId(option);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState(""); // State for search input
  const [searchFocused, setSearchFocused] = useState(false);
  const [listingTagFilter, setListingTagFilter] = useState(null);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const safeData = Array.isArray(data) ? data : [];
  const pageSizeOptions = [10, 25, 50, 100];

  const itemHasListingTagId = (item, tagId) => {
    if (tagId == null || tagId === "") return true;
    const tags = item?.business_tags;
    if (!Array.isArray(tags) || tags.length === 0) return false;
    const want = String(tagId);
    return tags.some((t) => {
      if (typeof t === "object" && t != null) {
        const id = t.value ?? t._id;
        return id != null && String(id) === want;
      }
      return false;
    });
  };

  const itemHasNoListingLabels = (item) => {
    const tags = item?.business_tags;
    return !Array.isArray(tags) || tags.length === 0;
  };

  const listingTagFilterOptions = useMemo(
    () => [
      { label: "(none)", value: LISTING_FILTER_NO_LABELS },
      ...businessTags,
    ],
    [businessTags]
  );

  // Filter by listing label (tag), then same fields as theme3 homepage SearchListing (name, tag labels, city, state, country, phone; multi-word AND).
  const filteredData = safeData?.filter((item) => {
    if (listingTagFilter?.value === LISTING_FILTER_NO_LABELS) {
      if (!itemHasNoListingLabels(item)) return false;
    } else if (listingTagFilter?.value != null) {
      if (!itemHasListingTagId(item, listingTagFilter.value)) return false;
    }
    return matchesHomepageSearchListing(item, searchQuery);
  });

  const totalItems = filteredData?.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));
  const maxButtonsToShow = 5;

  // Clamp currentPage to valid range
  const clampedPage = Math.min(currentPage, totalPages);

  // Prevent NaN and negative values
  const indexOfLastItem = Math.max(0, clampedPage * itemsPerPage);
  const indexOfFirstItem = Math.max(0, indexOfLastItem - itemsPerPage);

  // Sort the full filtered dataset first (so ordering is global), then slice for pagination
  const sortedData = [...(filteredData || [])];

  if (type === "premium") {
    sortedData.sort((a, b) => (a?.premium_order || 0) - (b?.premium_order || 0));
  } else if (type === "free") {
    sortedData.sort((a, b) => (a?.free_order || 0) - (b?.free_order || 0));
  } else {
    sortedData.sort((a, b) => (a?.order || 0) - (b?.order || 0));
  }

  // Slice the sorted array for current page
  const currentSlice = sortedData.slice(indexOfFirstItem, indexOfLastItem);
  let currentItems = [...(currentSlice || [])];

  const filteredIds = sortedData.map((d) => d.id);
  const currentPageIds = currentItems.map((d) => d.id);
  const allFilteredSelected =
    filteredIds.length > 0 && filteredIds.every((id) => selectedRows.includes(id));
  const allCurrentPageSelected =
    currentPageIds.length > 0 && currentPageIds.every((id) => selectedRows.includes(id));

  const handleToggleCurrentPage = () => {
    if (allCurrentPageSelected) {
      setSelectedRows((prev) => prev.filter((id) => !currentPageIds.includes(id)));
    } else {
      setSelectedRows((prev) => [...new Set([...prev, ...currentPageIds])]);
    }
  };

  const handleToggleSelectAllFiltered = () => {
    if (allFilteredSelected) {
      setSelectedRows([]);
    } else {
      setSelectedRows(filteredIds);
    }
  };

  const handlePageSizeChange = (e) => {
    setItemsPerPage(Number(e.target.value) || 10);
    setCurrentPage(1);
  };
 
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Calculate start and end of pagination buttons
  const startPage = Math.max(currentPage - Math.floor(maxButtonsToShow / 2), 1);
  const endPage = Math.min(startPage + maxButtonsToShow - 1, totalPages);

  const handleSwitchClick = async (item) => {
    if (item.plan_type === "free") {
      // Free → Premium: Open modal
      setSelectedPlan(item);
      setIsModalOpen(true);
    } else {
      // Premium → Free: Direct update
      setLoading(true);
      const payload = {
        _id: item.id,
        plan_type: "free",
        business_plan: {}, // omit plan_id completely to avoid cast error
      };

      const { response } = await AppService.accounts.update({ payload });
      if (response) {
        toast.success("Updated Successfully");
        onLoad();
      }
      setLoading(false);
    }
  };

  const handlePlanChange = async () => {
    if (!selectedPlan || !selectedPlanId?.value) {
      toast.error("Please select a plan");
      return;
    }

    setLoading(true);
    const payload = {
      _id: selectedPlan.id,
      plan_type: "premium",
      business_plan: {
        plan_id: selectedPlanId.value,
      },
    };

    const { response } = await AppService.accounts.update({ payload });
    if (response) {
      toast.success("Updated Successfully");
      onLoad();
      setIsModalOpen(false);
    }
    setLoading(false);
  };

  const handleSavePlanId = async (selectedPlanSubscribe) => {
    setLoading(true);
    const payload = {
      _id: selectedPlanSubscribe.id,
      business_plan: {
        plan_id: selectedPlanSubscribeId?.value,
      },
    };

    const { response } = await AppService.accounts.update({ payload });

    if (response) {
      onLoad();
      toast.success("Update Successfully");
      setLoading(false);
      setIsSubModelOpen(false);
    }
  };

  const handleChangePlanId = async (changePlan) => {
    setLoading(true);

    const payload = {
      _id: changePlan.id,
      business_plan: {
        plan_id: changePlanId?.value,
      },
    };

    const { response } = await AppService.accounts.update({ payload });

    if (response) {
      onLoad();
      toast.success("Update Successfully");
      setLoading(false);
      setChangeModelOpen(false);
    }
  };

  const DeleteAccount = async (id) => {
    const { response } = await AppService.accounts.DeleteBusiness({
      payload: { id },
      toaster: true,
    });
    if (response) {
      toast.success("Business tag removed successfully");
      onLoad();
    }
  };

  const openDeleteConfirm = (item) => {
    setBusinessToDelete(item);
    setDeleteConfirmText("");
    setDeleteConfirmOpen(true);
  };

  const closeDeleteConfirm = () => {
    if (deleting) return;
    setDeleteConfirmOpen(false);
    setBusinessToDelete(null);
    setDeleteConfirmText("");
  };

  const handleConfirmDelete = async () => {
    if (deleteConfirmText !== "DELETE" || !businessToDelete?.id) return;
    setDeleting(true);
    try {
      await DeleteAccount(businessToDelete.id);
    } finally {
      setDeleting(false);
      setDeleteConfirmOpen(false);
      setBusinessToDelete(null);
      setDeleteConfirmText("");
    }
  };

  const tableTHStyles = {
    fontFamily: isCompactAccountsTab ? '"Inter", "Segoe UI", sans-serif' : "Poppins",
    fontWeight: isCompactAccountsTab ? 700 : 600,
    fontSize: isCompactAccountsTab ? 13 : undefined,
    color: isCompactAccountsTab ? "#475467" : undefined,
  };

  const handlePremium = async (item) => {};

  const GetAgencyPlan = async () => {
    const { response } = await AppService.saas.agencysaas({
      query: `agency_id=${agency?._id}`,
    });
    if (response) {
      setAvailablePlan(response);
    }
  };
  useEffect(() => {
    GetAgencyPlan();
  }, []);

  const planfilter = availablePlan?.data?.filter((item) => !item?.is_free_saas);

  const planOptions = planfilter?.map((plan) => ({
    label: plan?.plan?.planName,
    value: plan?._id,
  }));

  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery, listingTagFilter, itemsPerPage]);

  const listingToolbarSelectStyles = useMemo(
    () => ({
      control: (base, state) => ({
        ...base,
        minHeight: toolbarFieldHeight,
        height: toolbarFieldHeight,
        minWidth: 0,
        fontSize: toolbarFontSize,
        borderRadius: TOOLBAR_RADIUS,
        border: TOOLBAR_BORDER,
        borderColor: state.isFocused ? "#a3a3a3" : "#cccccc",
        boxShadow: state.isFocused ? "0 0 0 1px #a3a3a3" : "none",
        backgroundColor: "#ffffff",
        cursor: "pointer",
        transition: "border-color 0.15s ease, box-shadow 0.15s ease",
      }),
      valueContainer: (base) => ({
        ...base,
        height: toolbarFieldHeight - 2,
        padding: "0 6px 0 10px",
        alignItems: "center",
      }),
      indicatorsContainer: (base) => ({
        ...base,
        height: toolbarFieldHeight - 2,
      }),
      dropdownIndicator: (base) => ({
        ...base,
        padding: "0 8px",
        color: "#6b7280",
      }),
      clearIndicator: (base) => ({
        ...base,
        padding: "0 6px",
        color: "#6b7280",
      }),
      indicatorSeparator: () => ({ display: "none" }),
      placeholder: (base) => ({
        ...base,
        color: TOOLBAR_PLACEHOLDER,
        fontSize: 14,
        fontFamily: '"Roboto", sans-serif',
        fontWeight: 500,
        margin: 0,
      }),
      singleValue: (base) => ({
        ...base,
        color: TOOLBAR_TEXT,
        fontSize: toolbarFontSize,
        margin: 0,
        lineHeight: `${toolbarFieldHeight - 4}px`,
      }),
      input: (base) => ({
        ...base,
        margin: 0,
        padding: 0,
        fontSize: toolbarFontSize,
        color: TOOLBAR_TEXT,
      }),
      menu: (base) => ({
        ...base,
        borderRadius: TOOLBAR_RADIUS,
        border: "1px solid #e5e7eb",
        boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
        overflow: "hidden",
        marginTop: 4,
      }),
      menuList: (base) => ({
        ...base,
        padding: 4,
        fontSize: toolbarFontSize,
      }),
      option: (base, state) => ({
        ...base,
        fontSize: toolbarFontSize,
        borderRadius: 4,
        padding: "8px 10px",
        backgroundColor: state.isSelected ? "#EB6753" : state.isFocused ? "#f3f4f6" : "transparent",
        color: state.isSelected ? "#fff" : TOOLBAR_TEXT,
        cursor: "pointer",
      }),
    }),
    [toolbarFontSize, toolbarFieldHeight]
  );

  const rootClassName =
    type === "all"
      ? "sd-accounts-all"
      : type === "premium"
        ? "sd-accounts-premium"
        : type === "free"
          ? "sd-accounts-free"
          : undefined;

  return (
    <div className={rootClassName}>
      <>
      {/* Search Input */}
      {data && data.length ? (
        <>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
              }}
            >
              <button
                type="button"
                className={isCompactAccountsTab ? "sd-accounts-all__action-btn" : undefined}
                onClick={() => navigate(`../sorted?type=${type}`)}
                style={{
                  marginTop: "-15px",
                }}
              >
                <HiArrowsUpDown className="sd-accounts-all__action-btn-icon" aria-hidden />
                Reorder
              </button>
              <button
                type="button"
                className={isCompactAccountsTab ? "sd-accounts-all__action-btn" : undefined}
                disabled={selectedRows.length === 0}
                onClick={() => handleTagsPopup("add")}
                style={{
                  marginTop: "-15px",
                }}
              >
                Add Listing labels
              </button>
              <button
                type="button"
                className={isCompactAccountsTab ? "sd-accounts-all__action-btn" : undefined}
                disabled={selectedRows.length === 0}
                onClick={() => handleTagsPopup("remove")}
                style={{
                  marginTop: "-15px",
                }}
              >
                Remove Listing labels
              </button>
            </div>

            <div
              style={{
                marginBottom: "20px",
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: "12px 16px",
                flex: "1 1 320px",
                maxWidth: "min(100%, 52rem)",
                minWidth: 0,
              }}
            >
              <div className="sd-toolbar-search" style={{ position: "relative" }}>
                <div className="sd-toolbar-search__icon">
                  <svg
                    width="25"
                    height="25"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_282_92)">
                      <path
                        d="M15 13.2955L12.3767 10.7727C13.1166 9.68182 13.5202 8.31818 13.5202 6.88636C13.5202 3.06818 10.4933 0 6.79372 0C3.09417 0 0 3.06818 0 6.88636C0 10.7045 3.02691 13.7727 6.79372 13.7727C8.27354 13.7727 9.61883 13.2955 10.6951 12.4773L13.3184 15.0682L15 13.2955ZM2.35426 6.88636C2.35426 4.43182 4.30493 2.45455 6.72646 2.45455C9.14798 2.45455 11.0987 4.43182 11.0987 6.88636C11.0987 9.34091 9.14798 11.3182 6.72646 11.3182C4.3722 11.3182 2.35426 9.34091 2.35426 6.88636Z"
                        fill="#E5E5E5"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_282_92">
                        <rect width="15" height="15" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <input
                  type="text"
                  className="sd-toolbar-search__input"
                  placeholder="Search by name, tag, city, state, country or phone"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onFocus={() => setSearchFocused(true)}
                  onBlur={() => setSearchFocused(false)}
                  style={{
                    maxWidth: TOOLBAR_SEARCH_MAX_WIDTH,
                    height: toolbarFieldHeight,
                    fontSize: toolbarFontSize,
                    lineHeight: `${toolbarFieldHeight - 2}px`,
                    color: TOOLBAR_TEXT,
                    borderWidth: 1,
                    borderStyle: "solid",
                    borderColor: searchFocused ? "#a3a3a3" : "#cccccc",
                    borderRadius: TOOLBAR_RADIUS,
                    backgroundColor: "#ffffff",
                    boxShadow: searchFocused ? "0 0 0 1px #a3a3a3" : "none",
                    outline: "none",
                    transition: "border-color 0.15s ease, box-shadow 0.15s ease",
                  }}
                />
              </div>
              <div className="sd-toolbar-select sd-account-table__listing-filter">
                <Select
                  aria-label="Filter listings by label"
                  inputId="account-table-listing-tag-filter"
                  isClearable
                  options={listingTagFilterOptions}
                  value={listingTagFilter}
                  onChange={(opt) => setListingTagFilter(opt)}
                  placeholder="All"
                  styles={listingToolbarSelectStyles}
                />
              </div>
            </div>
          </div>

          {selectedRows?.length > 0 && (
            <p
              className={isCompactAccountsTab ? "sd-accounts-all__selection-hint" : undefined}
              style={{ fontSize: "15px" }}
            >
              You have selected {selectedRows?.length} records.{" "}
              <span
                style={{ color: "#0fadfc", cursor: "pointer" }}
                onClick={handleToggleSelectAllFiltered}
              >
                {allFilteredSelected
                  ? `Unselect all ${filteredIds.length}`
                  : `Select all ${filteredIds.length} records`}
              </span>
            </p>
          )}
          {/* Table Layout */}
          <div style={{ width: "100%", overflowX: "auto" }}>
            <table
              className="table"
              style={{
                width: "100%",
                borderCollapse: "collapse",
                minWidth: "1200px",
                overflowX: "auto",
              }}
            >
              <thead>
                <tr style={{ background: "#F7F7F7", borderRadius: "18px" }}>
                  <th
                    className="p-20-px text-left"
                    style={{
                      ...tableTHStyles,
                      borderBottomLeftRadius: "18px",
                      borderTopLeftRadius: "18px",
                      whiteSpace: "nowrap",
                      maxWidth: "180px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={allCurrentPageSelected}
                        onChange={handleToggleCurrentPage}
                        style={{
                          accentColor: "#EB6753",
                          width: "16px",
                          height: "16px",
                          borderRadius: "4px",
                          border: "2px solid #EB6753",
                          cursor: "pointer",
                          marginRight: "10px",
                        }}
                        title={allCurrentPageSelected ? "Unselect page" : "Select page"}
                      />

                      <span>Listing Title</span>
                    </div>
                  </th>

                  <th
                    className="p-20-px text-left"
                    style={{
                      ...tableTHStyles,
                      whiteSpace: "nowrap",
                      maxWidth: "120px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Type
                  </th>
                  <th
                    className="p-20-px text-left"
                    style={{
                      ...tableTHStyles,
                      whiteSpace: "nowrap",
                      maxWidth: "220px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Listing labels
                  </th>
                  {!FreeAccount && (
                    <th
                      className="p-20-px text-left"
                      style={{
                        ...tableTHStyles,
                        whiteSpace: "nowrap",
                        maxWidth: "150px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      Plan Name
                    </th>
                  )}
                  <th
                    className="p-20-px text-left"
                    style={{
                      ...tableTHStyles,
                      whiteSpace: "nowrap",
                      maxWidth: "120px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Status
                  </th>
                  <th
                    className="p-20-px text-left"
                    style={{
                      ...tableTHStyles,
                      whiteSpace: "nowrap",
                      maxWidth: "180px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Address
                  </th>
                  <th
                    className="p-20-px text-left"
                    style={{
                      ...tableTHStyles,
                      whiteSpace: "nowrap",
                    }}
                  >
                    Date Created
                  </th>
                  <th
                    className="p-20-px text-left"
                    style={{
                      ...tableTHStyles,
                      whiteSpace: "nowrap",
                      maxWidth: "120px",
                    }}
                  >
                    Premium
                  </th>
                  <th
                    className="p-20-px text-left"
                    style={{
                      ...tableTHStyles,
                      borderBottomRightRadius: "18px",
                      borderTopRightRadius: "18px",
                      whiteSpace: "nowrap",
                      maxWidth: "120px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentItems?.length > 0 ? (
                  currentItems?.map((item, index) => (
                    <tr key={index}>
                      <td className="p-20-px" style={{ display: "flex", gap: "20px" }}>
                        <input
                          type="checkbox"
                          checked={selectedRows.includes(item.id)}
                          onChange={(e) => {
                            setSelectedRows((prev) => {
                              if (e.target.checked) {
                                return [...prev, item.id];
                              } else {
                                return prev.filter((id) => id !== item.id);
                              }
                            });
                          }}
                          style={{
                            accentColor: "#EB6753",
                            width: "20px",
                            height: "20px",
                            borderRadius: "6px",
                            border: "2px solid #EB6753",
                            cursor: "pointer",
                            marginRight: "8px",
                          }}
                          title="Select listing"
                        />
                        {item?.profile_image && (
                          <div
                            style={{
                              width: "150px",
                              height: "100px",
                              overflow: "hidden",
                              borderRadius: "12px",
                            }}
                          >
                            <img
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                              src={item?.profile_image}
                            />
                          </div>
                        )}
                        <div>
                          <h4
                            style={{
                              fontWeight: 600,
                            }}
                          >
                            {item.first_name}
                          </h4>
                          <p
                            style={{
                              fontWeight: 400,
                              fontSize: "15px",
                            }}
                          >
                            {item?.address}
                          </p>
                        </div>
                      </td>
                      <td className="p-20-px">
                        <span>{item?.plan_type === "premium" ? item?.plan_type : "Free"}</span>
                      </td>
                      <td className="p-20-px position-relative">
                        {item?.business_tags && item?.business_tags.length > 0 ? (
                          <>
                            {item.business_tags.slice(0, 1).map((tag, idx) => {
                              const tagText =
                                typeof tag === "object" ? tag.label || tag.value : tag;
                              return (
                                <span
                                  key={idx}
                                  style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    background: "#fff",
                                    color: "#222",
                                    padding: "7px 18px",
                                    borderRadius: "20px",
                                    fontSize: "14px",
                                    marginRight: "10px",
                                    marginBottom: "10px",
                                    fontWeight: 500,
                                    textTransform: "capitalize",
                                    border: "1px solid #e0e0e0",
                                    boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                                    letterSpacing: "0.02em",
                                    transition: "box-shadow 0.2s, border-color 0.2s",
                                    position: "relative",
                                  }}
                                  onMouseOver={(e) => {
                                    e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.10)";
                                    e.currentTarget.style.borderColor = "#EB6753";
                                  }}
                                  onMouseOut={(e) => {
                                    e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.04)";
                                    e.currentTarget.style.borderColor = "#e0e0e0";
                                  }}
                                >
                                  {tagText}
                                  {item.business_tags.length === 1 && (
                                    <img
                                      src={deleteIcon}
                                      alt="Delete"
                                      style={{
                                        position: "absolute",
                                        top: "-8px",
                                        right: "-8px",
                                        width: "18px",
                                        height: "18px",
                                        cursor: "pointer",
                                        background: "#fff",
                                        borderRadius: "50%",
                                        boxShadow: "0 1px 4px rgba(0,0,0,0.10)",
                                        border: "1px solid #EB6753",
                                        padding: "2px",
                                      }}
                                      onClick={async (e) => {
                                        e.stopPropagation();
                                        setLoading(true);
                                        // Remove the tag from business_tags
                                        const newTags = item.business_tags.filter((t) => {
                                          if (typeof t === "object" && typeof tag === "object") {
                                            return t.value !== tag.value;
                                          }
                                          return t !== tag;
                                        });
                                        await AppService.accounts.update({
                                          payload: {
                                            _id: item.id,
                                            business_tags: newTags,
                                          },
                                        });
                                        setLoading(false);
                                        onLoad();
                                      }}
                                      title="Delete tag"
                                    />
                                  )}
                                </span>
                              );
                            })}
                            {item.business_tags.length > 1 && (
                              <button
                                style={{
                                  background: "#EB6753",
                                  color: "#fff",
                                  border: "none",
                                  borderRadius: "20px",
                                  padding: "7px 18px",
                                  fontSize: "14px",
                                  fontWeight: 500,
                                  cursor: "pointer",
                                  marginBottom: "10px",
                                }}
                                onClick={() => {
                                  setShowTagsPopup({ id: item.id, tags: item.business_tags });
                                }}
                              >
                                More
                              </button>
                            )}
                            {/* Popup for all tags */}
                            {showTagsPopup?.id === item.id && (
                              <div
                                style={{
                                  position: "absolute",
                                  zIndex: 9999,
                                  background: "#fff",
                                  boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
                                  borderRadius: "16px",
                                  padding: "24px 32px",
                                  top: "0",
                                  left: "0",
                                  maxWidth: "500px",
                                }}
                              >
                                <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                                  {showTagsPopup.tags
                                    .filter((tag, idx) => !tagsToDelete.includes(tag))
                                    .map((tag, idx) => {
                                      const tagText =
                                        typeof tag === "object" ? tag.label || tag.value : tag;
                                      return (
                                        <span
                                          key={idx}
                                          style={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            background: "#fff",
                                            color: "#222",
                                            padding: "7px 18px 7px 12px",
                                            borderRadius: "20px",
                                            fontSize: "14px",
                                            fontWeight: 500,
                                            textTransform: "capitalize",
                                            border: "1px solid #e0e0e0",
                                            boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                                            letterSpacing: "0.02em",
                                            position: "relative",
                                            marginRight: "8px",
                                          }}
                                        >
                                          {tagText}
                                          <img
                                            src={deleteIcon}
                                            alt="Delete"
                                            style={{
                                              position: "absolute",
                                              top: "-8px",
                                              right: "-8px",
                                              width: "18px",
                                              height: "18px",
                                              cursor: "pointer",
                                              background: "#fff",
                                              borderRadius: "50%",
                                              boxShadow: "0 1px 4px rgba(0,0,0,0.10)",
                                              border: "1px solid #EB6753",
                                              padding: "2px",
                                            }}
                                            onClick={() => {
                                              setTagsToDelete((prev) => [...prev, tag]);
                                            }}
                                            title="Delete tag"
                                          />
                                        </span>
                                      );
                                    })}
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    marginTop: "18px",
                                  }}
                                >
                                  <button
                                    style={{
                                      background: "#EB6753",
                                      color: "#fff",
                                      border: "none",
                                      borderRadius: "20px",
                                      padding: "7px 18px",
                                      fontSize: "14px",
                                      fontWeight: 500,
                                      cursor: "pointer",
                                      marginRight: "10px",
                                    }}
                                    onClick={() => setShowTagsPopup(null)}
                                  >
                                    Close
                                  </button>
                                  <button
                                    style={{
                                      background: "black",
                                      color: "white",
                                      border: "none",
                                      borderRadius: "20px",
                                      padding: "7px 18px",
                                      fontSize: "14px",
                                      fontWeight: 500,
                                      cursor: "pointer",
                                    }}
                                    onClick={async () => {
                                      // Prepare new tags array
                                      const newTags = showTagsPopup.tags.filter(
                                        (tag, idx) => !tagsToDelete.includes(tag)
                                      );
                                      // Call backend update here
                                      setLoading(true);
                                      await AppService.accounts.update({
                                        payload: {
                                          _id: showTagsPopup.id,
                                          business_tags: newTags,
                                        },
                                      });
                                      setLoading(false);
                                      setShowTagsPopup(null);
                                      setTagsToDelete([]);
                                      onLoad();
                                    }}
                                  >
                                    Update
                                  </button>
                                </div>
                              </div>
                            )}
                          </>
                        ) : (
                          ""
                        )}
                      </td>
                      {!FreeAccount && (
                        <td className="p-20-px">
                          {item?.business_plan?.plan_id &&
                          item?.plan_type === "premium" &&
                          item?.plan ? (
                            <button
                              className="status-pill active"
                              style={{ border: "none", cursor: "pointer" }}
                              onClick={(e) => {
                                e.preventDefault();
                                setChangePlan(item);
                                setChangePlanId({
                                  label:
                                    item?.plan?.product_name || item?.plan?.plan?.planName || "N/A",
                                  value: item?.plan?._id,
                                });
                                setChangeModelOpen(true);
                              }}
                            >
                              {item?.plan?.plan?.planName}
                            </button>
                          ) : !item?.business_plan?.plan_id && item?.plan_type === "free" ? (
                            <span className="status-pill pending">Plan not subscribe</span>
                          ) : (
                            // UNCONFIGURED: when no plan_id or no plan object is available
                            item?.plan_type === "premium" &&
                            (!item?.business_plan?.plan_id || !item?.plan) && (
                              <button
                                className="status-pill processing"
                                style={{ border: "none", cursor: "pointer" }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  setSelectedPlanSubscribe(item);
                                  setIsSubModelOpen(true);
                                }}
                              >
                                UNCONFIGURED
                              </button>
                            )
                          )}
                        </td>
                      )}

                      <td className="p-20-px" style={{ textTransform: "capitalize" }}>
                        <span
                          className={`status-pill ${
                            item?.status === "active"
                              ? "active"
                              : item?.status === "pending"
                              ? "pending"
                              : item?.status === "published"
                              ? "published"
                              : item?.status === "processing"
                              ? "processing"
                              : "default"
                          }`}
                        >
                          {item?.status}
                        </span>
                      </td>
                      <td className="p-20-px">{item?.address || ""}</td>
                      <td className="p-20-px">
                        {new Date(item?.createdAt).toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                        })}
                      </td>
                      <td className="p-20-px text-right">
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            handleSwitchClick(item);
                          }}
                          style={{
                            background: "none",
                            border: "none",
                            color: "blue",
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                        >
                          <Switch checked={item?.plan_type === "premium"} />
                        </button>
                      </td>
                      <td className="p-20-px">
                        <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                          <img
                            onClick={() => navigate(`../account-detail/${item.id}`)}
                            width={20}
                            src={editIcon}
                            style={{ cursor: "pointer" }}
                          />
                          <img
                            onClick={(e) => {
                              e.stopPropagation();
                              openDeleteConfirm(item);
                            }}
                            width={20}
                            src={deleteIcon}
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={8} className="text-center">
                      No accounts found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {isModalOpen && (
            <div className="modal-zz-confirm">
              <div
                className="scrollable-modal-content bg-white  rounded"
                style={{ position: "relative" }}
              >
                <h2 className="text-black text-left font-14">Edit Business</h2>
                <span className="crossison" onClick={() => setIsModalOpen(false)}>
                  X
                </span>
                <p style={{ fontSize: "14px", marginBottom: "10px" }}>
                  Are you sure you want to change the plan type for{" "}
                  <strong>{selectedPlan?.first_name}</strong>?
                </p>
                <Select
                  options={planOptions}
                  value={selectedPlanId}
                  onChange={handleChange}
                  placeholder="Select a plan..."
                />
                <div style={{ marginTop: "20px", display: "flex", justifyContent: "flex-end" }}>
                  <button
                    type="submit"
                    style={{
                      background: "black",
                      color: "white",
                      padding: "10px 30px",
                      border: "none",
                      borderRadius: "10px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      handlePlanChange(selectedPlan);
                    }}
                  >
                    {loading ? "...Please wait" : "Save"}
                  </button>
                </div>
              </div>
            </div>
          )}

          {isSubModelOpen && (
            <div className="modal-zz-confirm">
              <div
                className="scrollable-modal-content bg-white  rounded"
                style={{ position: "relative" }}
              >
                <h2 className="text-black text-left font-14">Edit Business</h2>
                <span className="crossison" onClick={() => setIsSubModelOpen(false)}>
                  X
                </span>
                <p style={{ fontSize: "14px", marginBottom: "10px" }}>
                  Are you sure you want to change the plan type for{" "}
                  <strong>{selectedPlan?.first_name}</strong>?
                </p>
                <Select
                  options={planOptions}
                  value={selectedPlanSubscribeId}
                  onChange={handleSubscribeChange}
                  placeholder="Select a plan..."
                />
                <div style={{ marginTop: "20px", display: "flex", justifyContent: "flex-end" }}>
                  <button
                    type="submit"
                    style={{
                      background: "black",
                      color: "white",
                      padding: "10px 30px",
                      border: "none",
                      borderRadius: "10px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      handleSavePlanId(selectedPlanSubscribe);
                    }}
                  >
                    {loading ? "...Please wait" : "Save"}
                  </button>
                </div>
              </div>
            </div>
          )}
          {changeModelOpen && (
            <div className="modal-zz-confirm">
              <div
                className="scrollable-modal-content bg-white rounded"
                style={{ position: "relative" }}
              >
                <h2 className="text-black text-left font-14">Edit Plan Change</h2>
                <span className="crossison" onClick={() => setChangeModelOpen(false)}>
                  X
                </span>

                <p style={{ fontSize: "14px", marginBottom: "10px" }}>
                  Are you sure you want to change the plan type for{" "}
                  <strong>{changePlan?.first_name}</strong>?
                </p>

                <Select
                  options={planOptions}
                  value={changePlanId}
                  onChange={handlePlanConfigureChange}
                  placeholder="Select a plan..."
                />

                <div style={{ marginTop: "20px", display: "flex", justifyContent: "flex-end" }}>
                  <button
                    type="submit"
                    style={{
                      background: "black",
                      color: "white",
                      padding: "10px 30px",
                      border: "none",
                      borderRadius: "10px",
                      cursor: "pointer",
                    }}
                    onClick={() => handleChangePlanId(changePlan)}
                  >
                    {loading ? "...Please wait" : "Save"}
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Pagination Controls */}
          <div
            className={isCompactAccountsTab ? "sd-accounts-all__pagination" : undefined}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "20px",
              flexWrap: "wrap",
              gap: "16px",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                justifyContent: "center",
                gap: "4px",
              }}
            >
              <button
                type="button"
                title="First page"
                aria-label="First page"
                onClick={() => handlePageChange(1)}
                disabled={currentPage === 1}
                style={{
                  ...PAGINATION_ARROW_BTN,
                  cursor: currentPage === 1 ? "not-allowed" : "pointer",
                  opacity: currentPage === 1 ? 0.6 : 1,
                }}
              >
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 2,
                  }}
                  aria-hidden
                >
                  <img src={previousIcon} alt="" />
                  <img src={previousIcon} alt="" />
                </span>
              </button>
              <button
                type="button"
                title="Previous page"
                onClick={handlePreviousPage}
                disabled={currentPage === 1}
                style={{
                  ...PAGINATION_ARROW_BTN,
                  cursor: currentPage === 1 ? "not-allowed" : "pointer",
                  opacity: currentPage === 1 ? 0.6 : 1,
                }}
              >
                <img src={previousIcon} alt="" />
              </button>

              {[...Array(endPage - startPage + 1)].map((_, index) => {
                const pageNumber = startPage + index;
                return (
                  <button
                    key={pageNumber}
                    onClick={() => handlePageChange(pageNumber)}
                    style={{
                      padding: "8px 16px",
                      margin: "0 5px",
                      backgroundColor: pageNumber === currentPage ? "#EB6753" : "white",
                      color: pageNumber === currentPage ? "white" : "black",
                      border: "none",
                      borderRadius: "100px",
                      cursor: "pointer",
                    }}
                  >
                    {pageNumber}
                  </button>
                );
              })}

              <button
                type="button"
                title="Next page"
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
                style={{
                  ...PAGINATION_ARROW_BTN,
                  cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                  opacity: currentPage === totalPages ? 0.6 : 1,
                }}
              >
                <img src={nextIcon} alt="" />
              </button>
              <button
                type="button"
                title="Last page"
                aria-label="Last page"
                onClick={() => handlePageChange(totalPages)}
                disabled={currentPage === totalPages}
                style={{
                  ...PAGINATION_ARROW_BTN,
                  cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                  opacity: currentPage === totalPages ? 0.6 : 1,
                }}
              >
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 2,
                  }}
                  aria-hidden
                >
                  <img src={nextIcon} alt="" />
                  <img src={nextIcon} alt="" />
                </span>
              </button>
            </div>

            <label
              htmlFor="account-table-page-size"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                margin: 0,
                fontSize: isCompactAccountsTab ? 13 : 14,
                color: "#475467",
                whiteSpace: "nowrap",
              }}
            >
              Per page
              <select
                id="account-table-page-size"
                aria-label="Listings per page"
                value={itemsPerPage}
                onChange={handlePageSizeChange}
                style={{
                  height: 40,
                  minWidth: 72,
                  padding: "0 28px 0 12px",
                  fontSize: isCompactAccountsTab ? 13 : 14,
                  color: "#111827",
                  backgroundColor: "#ffffff",
                  border: "1px solid #e5e7eb",
                  borderRadius: 100,
                  boxShadow: "0px 1px 4px 0px #181A2012",
                  cursor: "pointer",
                  outline: "none",
                  appearance: "none",
                  WebkitAppearance: "none",
                  MozAppearance: "none",
                  backgroundImage:
                    "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236b7280' d='M3 4.5L6 7.5L9 4.5'/%3E%3C/svg%3E\")",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "right 10px center",
                }}
              >
                {pageSizeOptions.map((size) => (
                  <option key={size} value={size}>
                    {size}
                  </option>
                ))}
              </select>
            </label>
          </div>
        </>
      ) : (
        <p className="text-center">No record found ...</p>
      )}
      {deleteConfirmOpen && (
        <div className="modal-zz-confirm">
          <div
            className="scrollable-modal-content bg-white rounded"
            style={{ position: "relative", maxWidth: "500px" }}
          >
            <h2 className="text-black text-left font-14">Delete Business</h2>
            <span className="crossison" onClick={closeDeleteConfirm}>
              X
            </span>
            <p style={{ fontSize: "14px", marginBottom: "10px" }}>
              Are you sure you want to delete{" "}
              <strong>
                {businessToDelete?.first_name || businessToDelete?.business_name || "this business"}
              </strong>
              ? This action cannot be undone.
            </p>
            <p style={{ fontSize: "14px", marginBottom: "10px" }}>
              To confirm, type <strong>DELETE</strong> in the box below.
            </p>
            <input
              type="text"
              value={deleteConfirmText}
              onChange={(e) => setDeleteConfirmText(e.target.value)}
              placeholder="Type DELETE to confirm"
              style={{
                width: "100%",
                height: 46,
                boxSizing: "border-box",
                padding: "0 14px",
                fontSize: 16,
                color: "#111827",
                border: "1px solid #cccccc",
                borderRadius: 5,
                backgroundColor: "#ffffff",
                outline: "none",
              }}
            />
            <div
              style={{
                marginTop: "20px",
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              <button
                type="button"
                onClick={closeDeleteConfirm}
                disabled={deleting}
                style={{
                  background: "white",
                  color: "black",
                  padding: "10px 30px",
                  border: "1px solid #cccccc",
                  borderRadius: "10px",
                  cursor: deleting ? "not-allowed" : "pointer",
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleConfirmDelete}
                disabled={deleteConfirmText !== "DELETE" || deleting}
                style={{
                  background: deleteConfirmText === "DELETE" && !deleting ? "#d32f2f" : "#cccccc",
                  color: "white",
                  padding: "10px 30px",
                  border: "none",
                  borderRadius: "10px",
                  cursor:
                    deleteConfirmText === "DELETE" && !deleting ? "pointer" : "not-allowed",
                }}
              >
                {deleting ? "...Please wait" : "DELETE"}
              </button>
            </div>
          </div>
        </div>
      )}
      {showPopupModelTags && (
        <div>
          <div className="modal-zz-confirm">
            <div
              className="scrollable-modal-content bg-white  rounded"
              style={{ position: "relative", maxWidth: "500px" }}
            >
              <h2 className="text-black text-left font-14">
                {tagActionType === "add" ? "Add Listing labels" : "Remove Listing labels"}
              </h2>
              <span className="crossison" onClick={() => setShowPopupModelTags(false)}>
                X
              </span>
              <p style={{ fontSize: "14px", marginBottom: "10px" }}>
                {tagActionType === "add"
                  ? "Add Listing labels to the selected listings."
                  : "Remove Listing labels from the selected listings."}
              </p>
              <Select
                isMulti
                options={businessTags}
                value={selectedBusinessTags}
                onChange={(selected) => setSelectedBusinessTags(selected)}
                placeholder={
                  tagActionType === "add"
                    ? "Select Listing labels..."
                    : "Select Listing labels to remove..."
                }
              />
              <div style={{ marginTop: "20px", display: "flex", justifyContent: "flex-end" }}>
                <button
                  type="submit"
                  style={{
                    background: "black",
                    color: "white",
                    padding: "10px 30px",
                    border: "none",
                    borderRadius: "10px",
                    cursor: "pointer",
                  }}
                  onClick={async () => {
                    setLoading(true);
                    await AppService.accounts.UpdateTags({
                      payload: {
                        ids: selectedRows,
                        business_tags: selectedBusinessTags,
                        type: tagActionType,
                      },
                    });
                    setLoading(false);
                    setShowPopupModelTags(false);
                    setSelectedBusinessTags([]);
                    setSelectedRows([]);
                    onLoad();
                  }}
                >
                  {loading ? "...Please wait" : tagActionType === "add" ? "Save" : "Remove"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      </>
    </div>
  );
};

export default NewTable;

